import {
	AbstractControl,
	AsyncValidatorFn,
	ValidationErrors,
	Validators,
	ValidatorFn,
} from "@angular/forms";
import { Observable, empty, of } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { CodiceFiscaleService } from "./codice-fiscale/codice-fiscale.service";
import { Injectable } from "@angular/core";
// @Injectable()
// @dynamic
export class ValidationService {
	static capPattern = "[0-9][0-9][0-9][0-9][0-9]";
	static passwordPattern: RegExp = /^(?:(?=.*\d)(?=.*[A-Z]).{8,})/;
	static zeroCentoPattern = "^([0-9]|[1-9][0-9]|100)$";
	// tslint:disable-next-line:max-line-length
	static formatoData: RegExp = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
	static importoPattern = "^[0-9]+(,[0-9]{1,2}){0,1}$";
	// tslint:disable-next-line:max-line-length
	static formatoEmail: RegExp = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
	// tslint:disable-next-line:max-line-length
	static iban = /^(?:(?:IT|SM)\d{2}[A-Z]\d{22}|CY\d{2}[A-Z]\d{23}|NL\d{2}[A-Z]{4}\d{10}|LV\d{2}[A-Z]{4}\d{13}|(?:BG|BH|GB|IE)\d{2}[A-Z]{4}\d{14}|GI\d{2}[A-Z]{4}\d{15}|RO\d{2}[A-Z]{4}\d{16}|KW\d{2}[A-Z]{4}\d{22}|MT\d{2}[A-Z]{4}\d{23}|NO\d{13}|(?:DK|FI|GL|FO)\d{16}|MK\d{17}|(?:AT|EE|KZ|LU|XK)\d{18}|(?:BA|HR|LI|CH|CR)\d{19}|(?:GE|DE|LT|ME|RS)\d{20}|IL\d{21}|(?:AD|CZ|ES|MD|SA)\d{22}|PT\d{23}|(?:BE|IS)\d{24}|(?:FR|MR|MC)\d{25}|(?:AL|DO|LB|PL)\d{26}|(?:AZ|HU)\d{27}|(?:GR|MU)\d{28})$/;

	// /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/
	static codiceFiscale = /([a-z]{6}|[A-Z]{6})(l|m|n|p|q|r|s|t|u|v|L|M|N|P|Q|R|S|T|U|V|\d{1})(l|m|n|p|q|r|s|t|u|v|L|M|N|P|Q|R|S|T|U|V|\d{1})(a|b|c|d|e|h|l|m|p|r|s|t|A|B|C|D|E|H|L|M|P|R|S|T)((((l|m|n|p|q|r|s|t|u|v|L|M|N|P|Q|R|S|T|U|V|0|1|2|3|4|5|6)(l|m|n|p|q|r|s|t|u|v|L|M|N|P|Q|R|S|T|U|V|\d{1}))|71|70|TM|Tm|tM|tm|TL|tl|Tl|tL))([a-z]{1}|[A-Z]{1})(L|M|N|P|Q|R|S|T|U|V|\d{1})(l|m|n|p|q|r|s|t|u|v|L|M|N|P|Q|R|S|T|U|V|\d{1})(l|m|n|p|q|r|s|t|u|v|L|M|N|P|Q|R|S|T|U|V|\d{1})([a-z]{1}|[A-Z]{1})/;
	                       

	static partitaIva = /^[0-9]{11}$/;
	static partitaIvaMaxLen2 = /^[0-9]{2,11}$/;
	static codiceFiscalePiva =
		"^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$|^[0-9]{11}$";
	static _codiceFiscalePiva = /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$|^[0-9]{11}$/;
	static anno = /^[1-2][0-9]{3}$/;
	static nSentenza = /^[0-9]*\/[1-2][0-9]{3}$/;
	static numberPattern = /^[0-9]*$/;
	static phoneNumberPattern = /^\+{0,1}[0-9]*$/;
	static moneyPattern = /^([0-9]+)|((([1-9][0-9]*)|([0-9]))([,])[0-9]{2})$/;
	static moneyCommaSeparated = /^\d+,\d{2}$/;
	static numbers = /^\d+/;
	static formatoName: RegExp = /^[a-zA-Zàèìòùé ']+$/;

	constructor(private checkCFService: CodiceFiscaleService) { }

	static ValidateMail(control: AbstractControl) {
		if (ValidationService.formatoEmail.test(control.value)) {
			return null;
		}
		return { invalidMail: true };
	}

	static ValidateDate(control: AbstractControl) {
		if (new Date().getTime() < control.value) {
			return { invalidDate: true };
		}
		return null;
	}

	static ValidateName(control: AbstractControl) {
		if (ValidationService.formatoName.test(control.value)) {
			return null;
		}
		return { invalidName: true };
	}

	static ValidatePassword(control: AbstractControl) {
		if (ValidationService.passwordPattern.test(control.value)) {
			return null;
		}
		return { invalidPassword: true };
	}

	static ValidateIban(control: AbstractControl) {
		if (ValidationService.iban.test(control.value)) {
			return null;
		}
		return { invalidIban: true };
	}

	static ValidateCodiceFiscale(control: AbstractControl) {
		if (ValidationService.codiceFiscale.test(control.value)) {
			return null;
		}
		return { codiceFiscaleInvalido: true };
	}

	static ValidatePartitaIva(control: AbstractControl) {
		if (ValidationService.partitaIva.test(control.value)) {
			return null;
		}
		return { invalidPartitaIva: true };
	}

	static pattern(
		pattern: RegExp,
		error: string
	): (c: AbstractControl) => ValidationErrors | null {
		return (c: AbstractControl) =>
			Validators.pattern(pattern)(c) ? { [error]: true } : null;
	}

	static trigger(
		dependentControl: AbstractControl,
		predicate: (value: any) => boolean = (_) => _
	): (
			dependentValidators: Array<(c: AbstractControl) => ValidationErrors | null>
		) => (control: AbstractControl) => ValidationErrors | null {
		const originalValidator = dependentControl.validator;
		return (dependentValidators) => {
			return (control) => {
				if (predicate(control.value)) {
					for (const validator of dependentValidators) {
						const newError = validator(dependentControl);
						if (newError) {
							dependentControl.setErrors(newError);
							break;
						}
					}
					dependentControl.setValidators(dependentValidators);
				} else {
					dependentControl.setValidators(originalValidator);
					dependentControl.setErrors(null);
				}
				return null;
			};
		};
	}

	static NotEquals(value: any, message: string): ValidatorFn {
		return (control: AbstractControl) => {
			return value != control.value
				? null
				: {
					[message]: true,
				};
		};
	}

	userValidator(tipoPersona: string): AsyncValidatorFn {
		return (
			control: AbstractControl
		): Observable<{ [key: string]: any } | null> => {
			return this.checkCFService
				.validaCodiceFiscale$(control.value, tipoPersona)
				.pipe(
					map((outcome) => (!outcome.valid ? { invalidCF: true } : null)),
					catchError((error) => {
						return of({ validationServiceFailed: true });
					})
				);
		};
	}
}
